module.exports = __webpack_public_path__ + "static/media/imfinzi-imjudo-access360.22033083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imfinzi-imjudo-access360.png
// module id = 1380
// module chunks = 0